exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toggle{width:80px}.inactive{margin-left:-50%}.tile{width:50%;text-align:center;line-height:15px;flex-shrink:0;display:flex;flex-direction:column;justify-content:center;color:#fff;background:#ccc;transition:.13s}", ""]);

// exports
